// import CustomIcon from "../layouts/CustomIcon";
import { useAuthContext } from "../user/AuthProvider";

export default function PlanLabel({ className = "", noColor = false }) {
  const { planInfo } = useAuthContext();
  const { plan } = planInfo;

  return (
    <div className={`flex-item gap-1 ${noColor ? "p-4px" : "bg-F0FAFF text-2E62E9 p-4-8"} br-8px ${className}`}>
      {/* <CustomIcon name={isCustomPlan ? "rocket_01" : isPaidPlan ? "user_01" : "star_06"} /> */}
      <span className='fw-400 font-size-12px lh-20px'>{planInfo?.isTrialPlan ? plan?.name : `${plan?.name || "Free"} plan`}</span>
    </div>
  );
}
